import { SuggestionProps } from "./types";

export const collectAllSuggestions = <
  T extends {
    id: string;
    name: string;
    bid?: number;
    dailyBudgetCap?: number;
    biddingType?: string;
    suggestions?: any[];
    bidSuggestion?: { oldValue: number; newValue: number; change: number };
    dailyCapSuggestion?: { oldValue: number; newValue: number; change: number };
  }
>(
  tableData: T[]
): SuggestionProps[] => {
  const allSuggestions: SuggestionProps[] = [];

  tableData.forEach((campaign) => {
    if (
      campaign.biddingType === "cpa" &&
      !campaign.bidSuggestion &&
      !campaign.dailyCapSuggestion
    ) {
      return;
    }

    if (campaign.suggestions && Array.isArray(campaign.suggestions)) {
      campaign.suggestions.forEach((suggestion: any) => {
        if (suggestion) {
          if (suggestion.bidIncrease || suggestion.budgetCapMultiplier) {
            const type = suggestion.bidIncrease ? "bid" : "daily_cap";
            const change =
              type === "bid"
                ? suggestion.bidIncrease
                : suggestion.budgetCapMultiplier;
            const oldValue =
              type === "bid" ? campaign.bid || 0 : campaign.dailyBudgetCap || 0;
            const newValue =
              type === "bid" ? oldValue + change : oldValue * change;

            allSuggestions.push({
              id: suggestion.id,
              type,
              oldValue,
              newValue,
              change: type === "bid" ? change : (change - 1) * 100,
              campaign: {
                id: campaign.id,
                name: campaign.name,
              },
            });
          } else {
            allSuggestions.push({
              ...suggestion,
              campaign: {
                id: campaign.id,
                name: campaign.name,
              },
            });
          }
        }
      });
    } else {
      if (campaign.bidSuggestion) {
        allSuggestions.push({
          id: parseInt(`${campaign.id}1`),
          type: "bid",
          oldValue: campaign.bidSuggestion.oldValue,
          newValue: campaign.bidSuggestion.newValue,
          change: campaign.bidSuggestion.change,
          campaign: {
            id: campaign.id,
            name: campaign.name,
          },
        });
      }

      if (campaign.dailyCapSuggestion) {
        allSuggestions.push({
          id: parseInt(`${campaign.id}2`),
          type: "daily_cap",
          oldValue: campaign.dailyCapSuggestion.oldValue,
          newValue: campaign.dailyCapSuggestion.newValue,
          change: campaign.dailyCapSuggestion.change,
          campaign: {
            id: campaign.id,
            name: campaign.name,
          },
        });
      }
    }
  });

  return allSuggestions;
};

export const groupSuggestionsByCampaign = (suggestions: SuggestionProps[]) => {
  return suggestions.reduce(
    (
      acc: { [key: string]: { name: string; suggestions: SuggestionProps[] } },
      suggestion
    ) => {
      const campaignId = suggestion.campaign.id;
      if (!acc[campaignId]) {
        acc[campaignId] = {
          name: suggestion.campaign.name,
          suggestions: [],
        };
      }
      acc[campaignId].suggestions.push(suggestion);
      return acc;
    },
    {}
  );
};
